@if (title(); as titleText) {
  <h1 class="page-title">{{ titleText }}</h1>
}
